import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css';
import "./assets/scss/style.scss";

export default {
    install(Vue) {
        Vue.use(Vuetify, {
            theme: 
            {
                dark: false,
                primary: '#FFF',
                secondary: '#FFF',
                accent: '#FFF',
                error: '#FFF',
                warning: '#FFF',
                info: '#FFF',
                success: '#FFF'
            }
        });        
    }
}